// crea un componente de react que se llame Ponderated.js y lo importas en el index.js de LikertForm y lo usas en el renderPonderated
//
// Ponderated.js
import React, { Fragment } from "react"
import { Popover, Radio, Divider } from "antd"
import { QuestionIcon } from "../../../../icons/svg/iconQuestion"
import { QUESTION_PONDERATED } from "../../../../utils/constants"
import { isModuleBySlug } from "../../../../utils/storage"


export function Ponderated (props) {

  const renderPopoverPonderated = () => {
    return (
      <Popover
        placement="bottomLeft"
        align={{ offset: [-10, 0] }}
        content={
          <div style={{ width: 368, fontSize: 13 }}>
            <span>
              El ponderador determina si la pregunta tendrá un impacto en el
              resultado de la subdimensión/dimensión a la que pertenece
            </span>
            <ul style={{ paddingLeft: 24 }}>
              <li>
                <span style={{ marginLeft: "-4px" }}>
                  Si el ponderador es <strong>1</strong>, la pregunta sí se
                  tomará en cuenta para el cálculo de la subdimensión/dimensión.
                </span>
              </li>
              <li>
                <span style={{ marginLeft: "-4px" }}>
                  Si el ponderador es <strong>0</strong>, aunque la pregunta
                  estará incluida en la encuesta, su resultado{" "}
                  <strong>no</strong> será tomando en consideración para el
                  cálculo de la subdimensión/dimensión.
                </span>
              </li>
            </ul>
          </div>
        }
        overlayClassName="PopoverPonderated">
        <QuestionIcon />
      </Popover>
    )
  }

  const {
    onChangePonderated,
    ponderated,
    engagementCheck,
    surveyData,
  } = props

  const isQuestionPonderated = isModuleBySlug(QUESTION_PONDERATED)

  if (engagementCheck) {
    return null
  }

  const options = [
    { label: "0", value: "0" },
    { label: "1", value: "1" },
  ]

  return isQuestionPonderated && (
    <Fragment>
        <Divider style={{ margin: "16px 0" }} />
        <div className="Ponderated">
          <div className="Ponderated__Header">
            <strong className="Ponderated__Header--title">Ponderador</strong>
            {renderPopoverPonderated()}
          </div>
          <div className="Ponderated__RadioButton">
            <Radio.Group
              disabled={surveyData.measures?.length > 0}
              options={options}
              onChange={(e) => onChangePonderated(e.target.value)}
              value={ponderated}
              optionType="button"
            />
          </div>
        </div>
      </Fragment>
  )
}

export default Ponderated
